<template>
  <div>
    <div v-if="documentData">
      <iframe :src="documentData" width="100%" height="700px"></iframe>
    </div>
    <div v-if="errorMessage">
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      documentData: null,
      errorMessage: null,
    };
  },
  created() {
    this.fetchDocument();
  },
  methods: {
    async fetchDocument() {
      try {
        console.log("Kiran path", this.$route.path);

        if (this.$route.path.startsWith('/image-display')) {
          const transactionId = this.$route.params.txnId;
          const response = await axios.get(`/api/bluestar/${transactionId}`, {
            responseType: 'arraybuffer',
          });
          if (response.status === 200) {
            const contentType = response.headers['content-type'];
            const pdfBlob = new Blob([response.data], { type: contentType });
            this.documentData = URL.createObjectURL(pdfBlob);
          } else {
            this.errorMessage = 'Failed to fetch the document.';
          }

        } else if (this.$route.path.startsWith('/s3-display')) {

          const fileName = this.$route.params.filename.trim();

          const response = await axios.get(`/api/s3-file-view/Service Ticket_${fileName}.pdf`, {
            responseType: 'arraybuffer',
          });
          if (response.status === 200) {
            const contentType = response.headers['content-type'];
            const blob = new Blob([response.data], { type: contentType });
            this.documentData = URL.createObjectURL(blob);
          } else {
            this.errorMessage = 'Failed to fetch the S3 image.';
          }
          console.log("response",response)

        } else {
          this.errorMessage = 'Unknown path.';
        }
      } catch (error) {
        console.error('Error fetching document:', error);
        this.errorMessage = 'An error occurred while fetching the document.';
      }
    },
  },
};
</script>
